export interface PortalAccessIdentity {
  tenantId?: string | null | undefined;
  roles?: readonly string[] | null | undefined;
}

const QUICKDIAL_ADMIN_ROLE = 'quickdial.admin';

function normalizeValue(value?: string | null): string | undefined {
  const normalizedValue = value?.trim().toLowerCase();
  return normalizedValue ? normalizedValue : undefined;
}

function normalizeRoles(roles?: readonly string[] | null): string[] {
  return (roles ?? []).reduce<string[]>((normalizedRoles, role) => {
    const normalizedRole = normalizeValue(role);

    if (normalizedRole) {
      normalizedRoles.push(normalizedRole);
    }

    return normalizedRoles;
  }, []);
}

export function canAccessPortal(
  identity: PortalAccessIdentity,
  hostingTenantId?: string | null,
): boolean {
  const normalizedTenantId = normalizeValue(identity.tenantId);
  const normalizedHostingTenantId = normalizeValue(hostingTenantId);
  const hasHostingTenantAccess = Boolean(
    normalizedTenantId &&
    normalizedHostingTenantId &&
    normalizedTenantId === normalizedHostingTenantId,
  );
  const hasAdminRole = normalizeRoles(identity.roles).includes(QUICKDIAL_ADMIN_ROLE);

  return hasHostingTenantAccess && hasAdminRole;
}